import React from 'react';
import { Box, Typography } from '@mui/material';
import FaceIcon from '@mui/icons-material/Face';
import { designTokens } from '../theme/designTokens';

const LearnersPage = () => {
    return (
        <Box sx={{ p: 4, maxWidth: 1200, mx: 'auto' }}>
            <Box sx={designTokens.pageHeader}>
                <Typography variant="h4" sx={designTokens.pageTitle}>
                    <FaceIcon fontSize="large" /> Gestion des Apprenants
                </Typography>
            </Box>
            <Box sx={{
                p: 4,
                bgcolor: 'rgba(255,255,255,0.5)',
                backdropFilter: 'blur(10px)',
                borderRadius: 4,
                textAlign: 'center'
            }}>
                <Typography variant="h6" color="text.secondary">
                    Module en cours de développement.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Cette application sera détaillée prochainement.
                </Typography>
            </Box>
        </Box>
    );
};

export default LearnersPage;
